function batteryMult(){
  if(!HAS_BATTERY.includes(sell.cat)) return 1;
  const b=battInfo(); return b?b.m:1;
}
function battLabel(){ const b=battInfo(); return b ? (b.k==='unk'?'Battery to be checked':'Battery '+b.t.charAt(0).toLowerCase()+b.t.slice(1)) : null; }
const CONN_CATS=['ipad'];
function ctrlMult(){ return sell.cat==='gaming' && sell.ctrl==='no' ? 0.9 : 1; }
function connMult(){ return CONN_CATS.includes(sell.cat) && sell.conn==='cell' ? 1.06 : 1; }
function gradePriceSell(g){
  let v = modelBase();
  const cap = capList()[sell.storage]; if(cap) v*=cap[1];
  v *= connMult();
  v *= ctrlMult();
  v *= batteryMult();
  v *= g.m;
  return Math.max(5, Math.round(v/5)*5);
}
function maxPrice(){
  if(sell.storage==null) return upTo(sell.model, modelBase());
  let v = modelBase();
  const cap = capList()[sell.storage]; if(cap) v*=cap[1];
  v *= connMult();
  return Math.round(v/5)*5;
}
function offerValue(){
  const g = GRADES_SELL.find(x=>x.k===sell.grade) || GRADES_SELL[0];
  return gradePriceSell(g);
}

function itemBar(){
  const cap = capList()[sell.storage];
  const bits = [cap?cap[0]:null, HAS_BATTERY.includes(sell.cat)?battLabel():null, sell.contract==='yes'?'Under contract':null].filter(Boolean);
  return `<div class="itembar">
    ${art(modelArt(sell.model,sell.cat),sell.model,44)}
    <div><b>${sell.model}</b><span>${bits.join(' · ')||'Tell us the details'}</span>
      <button class="changeitem" data-sellstep="1">Change item</button></div>
  </div>`;
}
function stepBar(i){
  return `<div class="stephead"><span>Step ${i} of 5</span><b>${STEP_LABELS[i]}</b></div>
    <div class="steps">${STEP_LABELS.slice(1).map((_,n)=>`<span class="step ${n<i?'on':''}"></span>`).join('')}</div>`;
}

function pageSell(){
  let inner='';

  if(sell.step===0){
    const q=(sell.find||'').trim().toLowerCase();
    const all = Object.entries(TRADE).flatMap(([c,o])=>o.list.map(m=>[c,m[0],m[1]]));
    const hits = q ? all.filter(x=>x[1].toLowerCase().includes(q)).slice(0,8) : [];
    const popular = [...all].map(([c,m,v])=>[c,m,upTo(m,v)]).sort((a,b)=>b[2]-a[2]).slice(0,8);
    inner = `
    <div class="sellsearch">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
      <input id="modelFind" placeholder="Search your model" value="${sell.find||''}" aria-label="Search every model we buy">
    </div>
    ${q?(hits.length?`<div class="catlist">${hits.map(([c,m,v])=>`<button class="catrow" data-sellquick="${c}|${m}">${art(modelArt(m,c),'',44)}<span>${m}</span><b>Up to ${money(upTo(m,v))}</b></button>`).join('')}</div>`
      :`<p class="hint" style="text-align:center">No match for “${sell.find}”. <a class="seclink" href="#/care/contact">Send us the model</a></p>`):''}

    <h2 class="selltitle">What are you selling?</h2>
    <div class="catlist big">
      ${Object.entries(TRADE).map(([k,o])=>`<button class="catrow" data-sellcat="${k}">${art(o.art,o.label,56)}<span>${o.label}</span><i aria-hidden="true">›</i></button>`).join('')}
    </div>
    <p class="notlisted">Not listed? <a class="seclink" href="#/care/contact">Request a quote</a></p>

    <h2 class="selltitle" style="margin-top:34px">Top payouts</h2>
    <div class="payrow" aria-label="Top payouts">
      ${popular.map(([c,m,v])=>`<button class="paypill" data-sellquick="${c}|${m}"><span>${m}</span><b>${money(v)}</b></button>`).join('')}
    </div>

    <div class="how3">
      <div><b>1</b><span><strong>Get your price</strong>A few questions, about a minute.</span></div>
      <div><b>2</b><span><strong>Hand it over</strong>Free pickup, a meetup, or a prepaid label.</span></div>
      <div><b>3</b><span><strong>Get paid</strong>Cash or e-Transfer, the same day it passes inspection.</span></div>
    </div>

    <div class="sfaq slim">
      <details><summary>Is my offer guaranteed?</summary><p>Yes, if the device matches what you described. If not, you get a revised offer with the reason, and if you decline we send it back free.</p></details>
      <details><summary>Do you buy broken devices?</summary><p>Yes. Cracked screens, weak batteries, devices that will not turn on. Pick Broken and you still get a price.</p></details>
      <details><summary>What do I do before handing it over?</summary><p>Sign out of iCloud or Google and erase it. <a class="seclink" href="#/care/wipe">Here is how</a>.</p></details>
      <details><summary>Are there any fees?</summary><p>No. You receive the amount you accept.</p></details>
    </div>`;
  } else if(sell.step===1){
    const q=(sell.find||'').toLowerCase();
    const list=TRADE[sell.cat].list.filter(m=>!q||m[0].toLowerCase().includes(q));
    inner = `<a class="backlink" data-sellstep="0">‹ Back</a>${stepBar(1)}
      <div class="qs"><h2>${({iphone:'Which iPhone?',android:'Which Android phone?',ipad:'Which iPad?',mac:'Which Mac?',watch:'Which smartwatch?',audio:'Which AirPods or headphones?',gaming:'Which console or controller?'})[sell.cat]}</h2>
      <p class="hint">Best-case prices. Your answers set the exact offer.</p>
      <input class="field" id="modelFind" placeholder="Type a model name" value="${sell.find||''}" aria-label="Find your model">
      ${list.length?list.map(m=>`<button class="pick" data-sellmodel="${m[0]}"><span>${m[0]}<small>${capsFor(m[0]).length>1?capsFor(m[0])[0][0]+' to '+capsFor(m[0])[capsFor(m[0]).length-1][0]+' · ':''}Up to ${money(upTo(m[0],m[1]))}</small></span><span class="arrow">›</span></button>`).join('')
        :`<p class="hint">Nothing matches that. <a class="seclink" href="#/care/contact">Tell us the model</a> and we price it individually.</p>`}
      </div>`;

  } else if(sell.step===2){
    const needsCarrier = sell.contract==='yes' && ['iphone','android'].includes(sell.cat);
    const needsConn = CONN_CATS.includes(sell.cat);
    const needsCtrl = sell.cat==='gaming' && /PlayStation 5|PS5|Xbox Series|Switch/i.test(sell.model||'');
    const needsBatt = HAS_BATTERY.includes(sell.cat);
    const caps = capList();
    if(caps.length===1) sell.storage = 0;
    const ready = sell.contract!=null && sell.storage!=null && (!needsBatt || sell.batt) && (!needsConn || sell.conn) && (!needsCtrl || sell.ctrl) && !(needsCarrier && (!sell.carrier || blockedCarrier()));
    inner = `<a class="backlink" data-sellstep="1">‹ Back</a>${stepBar(2)}${itemBar()}
      <div class="uptop"><span>Up to</span><b>${money(maxPrice())}</b></div>

      <section class="card2">
        <h3>Is it under contract or still financed?</h3>
        <div class="twocol">
          <button class="opt big ${sell.contract==='yes'?'on':''}" data-sellcontract="yes">Yes</button>
          <button class="opt big ${sell.contract==='no'?'on':''}" data-sellcontract="no">No</button>
        </div>
        ${needsCarrier?`
          <h3 class="sub">Which carrier is it financed with?</h3>
          <div class="twocol">
            ${CARRIERS.map(c=>`<button class="opt big carrier ${sell.carrier===c[0]?'on':''} ${c[1]?'no':''}" data-sellcarrier="${c[0]}">${c[0]}${c[1]?'<small>Not accepted</small>':''}</button>`).join('')}
          </div>
          ${sell.carrier?(blockedCarrier()?`
            <div class="blocked">
              <b>We cannot take this one</b>
              <p>A device still financed with ${sell.carrier} stays tied to the account until the balance is settled, so we are not able to buy it. Clear the balance and the offer comes back.</p>
              <div class="blockbtns">
                <button class="btn sm line" data-sellstep="1">Change item</button>
                <button class="btn sm" data-sellcarrier="">Pick another carrier</button>
              </div>
            </div>`:`
            <p class="note">Fine with us. The balance still has to be cleared with ${sell.carrier} before we can pay you. We will help you sort it out.</p>`):''}
        `:''}
      </section>

      ${caps.length>1?`<section class="card2">
        <h3>${CAP_TITLE[sell.cat]||'Configuration'}</h3>
        <div class="twocol">
          ${caps.map((c,i)=>`<button class="opt big ${sell.storage===i?'on':''}" data-sellstorage="${i}">${c[0]}</button>`).join('')}
        </div>
        ${sell.cat==='mac'?`<p class="hint" style="margin:10px 0 0">Apple menu › About This Mac shows the memory and the storage.</p>`:''}
        ${['iphone','android','ipad'].includes(sell.cat)?`<p class="hint" style="margin:10px 0 0">Settings › General › About shows the capacity.</p>`:''}
      </section>`:''}

      ${needsCtrl?`<section class="card2">
        <h3>${/Switch/.test(sell.model)?'Are both Joy-Con included?':'Is a controller included?'}</h3>
        <div class="twocol">
          <button class="opt big ${sell.ctrl==='yes'?'on':''}" data-sellctrl="yes">Yes</button>
          <button class="opt big ${sell.ctrl==='no'?'on':''}" data-sellctrl="no">No</button>
        </div>
      </section>`:''}

      ${needsConn?`<section class="card2">
        <h3>Wi-Fi or Wi-Fi + Cellular?</h3>
        <div class="twocol">
          <button class="opt big ${sell.conn==='wifi'?'on':''}" data-sellconn="wifi">Wi-Fi</button>
          <button class="opt big ${sell.conn==='cell'?'on':''}" data-sellconn="cell">Wi-Fi + Cellular</button>
        </div>
        <p class="hint" style="margin:10px 0 0">Cellular models have a SIM tray on the side.</p>
      </section>`:''}

      ${HAS_BATTERY.includes(sell.cat)?`
      <section class="card2">
        <h3>Battery health <button class="helplink" data-sellhelp>Where do I find it?</button></h3>
        ${sell.help?`<div class="helpbox"><b>Where to look</b><p>iPhone: Settings › Battery › Battery Health › Maximum Capacity.<br>Mac: hold Option, click the Apple menu › System Information › Power.<br>Android: Settings › Battery, or dial *#*#4636#*#*.</p></div>`:''}
        <div class="battgrid">
          ${BATT.map(x=>`<button class="opt big ${sell.batt===x.k?'on':''}" data-sellbatt="${x.k}">${x.t}</button>`).join('')}
        </div>
        ${sell.batt==='unk'?`<p class="hint" style="margin:10px 0 0">No problem. We check it at inspection, and if it is better than expected, you get more.</p>`:''}
      </section>`:''}

      <div style="height:78px"></div>
      <div class="stickybar">
        <div><span>Estimate</span><b>${money(gradePriceSell(GRADES_SELL[0]))}</b></div>
        <button class="btn" data-sellstep="3" ${ready?'':'disabled'}>Continue</button>
      </div>`;

  } else if(sell.step===3){
    inner = `<a class="backlink" data-sellstep="2">‹ Back</a>${stepBar(3)}${itemBar()}
      <div class="qs"><h2>Select the condition</h2>
      <p class="hint">Pick the one that matches. Accurate answers mean the price does not move at inspection.</p></div>
      <div class="gradesell">
        ${GRADES_SELL.map(g=>`<button class="gsell ${sell.grade===g.k?'on':''}" data-sellgrade="${g.k}">
          <span class="radio"></span>
          <span class="gtxt"><b>${g.t}</b><small>${g.d}</small></span>
          <span class="gprice">${money(gradePriceSell(g))}</span>
        </button>`).join('')}
      </div>
      <div style="height:78px"></div>
      <div class="stickybar">
        <div><span>${sell.grade?'Your offer':'Select a condition'}</span><b>${sell.grade?money(offerValue()):'—'}</b></div>
        <button class="btn" data-sellstep="4" ${sell.grade?'':'disabled'}>See my offer</button>
      </div>`;

  } else if(sell.step===4){
    const v = offerValue();
    const cap = capList()[sell.storage];
    const g = GRADES_SELL.find(x=>x.k===sell.grade);
    const ho = sell.handoff||'pickup';
    const basket = sell.basket||[];
    const total = v + basket.reduce((a,b)=>a+b.value,0);
    inner = `<a class="backlink" data-sellstep="3">‹ Back</a>${stepBar(4)}
      <div class="offercard">
        <div class="ohero">${art(modelArt(sell.model,sell.cat),sell.model,70)}
          <div><b>${sell.model}</b><span>${[cap?cap[0]:null,CONN_CATS.includes(sell.cat)?(sell.conn==='cell'?'Wi-Fi + Cellular':'Wi-Fi'):null,g.t,HAS_BATTERY.includes(sell.cat)?battLabel():null].filter(Boolean).join(' · ')}</span></div>
        </div>
        <p class="olabel">${basket.length?'This device':'Your offer'}</p>
        <div class="oamt">${money(v)}<small>CAD</small></div>
        ${basket.length?`<div class="basket">
          ${basket.map((b,i)=>`<div><span>${b.model}<small>${b.spec}</small></span><b>${money(b.value)}</b><button data-sellrm="${i}" aria-label="Remove">×</button></div>`).join('')}
          <div class="btot"><span>Combined offer, ${basket.length+1} devices</span><b>${money(total)}</b></div>
        </div>`:''}
        <button class="addmore" data-selladd>+ Add another device</button>
        <p class="opaid">${ho==='ship'?'Paid by Interac e-Transfer the day it passes inspection, within two business days of arrival.':'Tested in front of you and paid on the spot, in cash or by Interac e-Transfer.'}</p>

        <p class="olabel" style="margin-top:18px">How do you want to hand it over?</p>
        <div class="handoff three">
          <button class="ho ${ho==='pickup'?'on':''}" data-sellhandoff="pickup"><b>Free pickup</b><span>We come to you in Ottawa–Gatineau.</span></button>
          <button class="ho ${ho==='meet'?'on':''}" data-sellhandoff="meet"><b>Meetup</b><span>An agreed public place nearby.</span></button>
          <button class="ho ${ho==='ship'?'on':''}" data-sellhandoff="ship"><b>Free mail-in</b><span>Prepaid tracked label, anywhere in Canada.</span></button>
        </div>
        ${ho!=='ship'?`<div class="seg" role="group" aria-label="Paid by">
          <button class="${(sell.pay||'etransfer')==='etransfer'?'on':''}" data-sellpay="etransfer">e-Transfer</button>
          <button class="${sell.pay==='cash'?'on':''}" data-sellpay="cash">Cash</button>
        </div>`:''}

        <input class="field" id="sellName" autocomplete="name" placeholder="Your name" value="${sell.name||''}" aria-label="Your name">
        <input class="field" id="sellContact" autocomplete="email" placeholder="Email or phone number" value="${sell.contact||''}" aria-label="Email or phone number">
        ${sell.emailErr?`<p class="err">${sell.emailErr}</p>`:''}
        <button class="btn wide" data-selllock>${ho==='pickup'?'Book my free pickup':ho==='meet'?'Arrange a meetup':'Get my free label'} · ${money(total)}</button>
        <p class="ofine">By continuing, you confirm you own the device. No obligation to sell.</p>
        ${v<=25?`<p class="lowoffer">This one is worth very little. If you prefer, we can take it for recycling on any pickup, free.</p>`:''}
        <p class="olock">We honour ${money(total)} for 14 days, even if prices drop.</p>
      </div>

      <details class="pricedet"><summary>How we priced it</summary>
      <div class="openbook">
        <h3>Where the price comes from</h3>
        <div class="obrow"><span>What we expect to resell it for, once tested and warrantied</span><b>${money(Math.round(v/0.66/5)*5)}</b></div>
        <div class="obrow"><span>Testing, parts, 12-month warranty, shipping and returns</span><b>−${money(Math.round(v/0.66/5)*5 - v)}</b></div>
        <div class="obrow tot"><span>Your offer</span><b>${money(v)}</b></div>
        <p class="obnote">Typical figures for this category. If it needs less work than we expect, we pay you more at inspection.</p>
      </div>

      <h3 class="dhead">Your answers</h3>
      <ul class="qlines">
        <li><span>${sell.model}</span><b>${money(modelBase())}</b></li>
        ${cap&&capList().length>1?`<li><span>${cap[0]}</span><b>${cap[1]!==1?(cap[1]>1?'+':'−')+Math.round(Math.abs(1-cap[1])*100)+'%':'no change'}</b></li>`:''}
        ${HAS_BATTERY.includes(sell.cat)&&sell.batt?`<li><span>${battLabel()}</span><b>Included</b></li>`:''}
        <li><span>${g.t} condition</span><b>${g.m===1?'no change':'−'+Math.round((1-g.m)*100)+'%'}</b></li>
        ${sell.cat==='gaming'&&sell.ctrl?`<li><span>${sell.ctrl==='yes'?'Controller included':'No controller'}</span><b>Included</b></li>`:''}
        ${CONN_CATS.includes(sell.cat)?`<li><span>${sell.conn==='cell'?'Wi-Fi + Cellular':'Wi-Fi'}</span><b>Included</b></li>`:''}
        <li class="tot"><span>Total</span><b>${money(v)}</b></li>
      </ul>
      </details>
      <button class="backlink" style="margin-top:16px" data-sellreset>Start over</button>`;

  } else {
    const v = offerValue();
    const pick = (sell.handoff||'pickup')!=='ship';
    const meet = sell.handoff==='meet';
    const total = v + (sell.basket||[]).reduce((a,b)=>a+b.value,0);
    const slots=['Today 5–8pm','Tomorrow 9am–12pm','Tomorrow 1–5pm','Saturday 10am–4pm'];
    inner = `${stepBar(5)}
      <div class="qs"><h2>${pick?'Pick a time':'Your label is on its way'}</h2>
        <p class="hint">${money(total)} for ${(sell.basket||[]).length?((sell.basket.length+1)+' devices'):'your '+sell.model}, held 14 days. ${/@/.test(sell.contact||'')?'Confirmation sent to '+sell.contact:'We will text '+(sell.contact||'you')+' to confirm'}.</p></div>
      ${pick?`
      <div class="zone">
        <h3>${meet?'When suits you?':'When should we come by?'}</h3>
        <div class="slots">${slots.map(x=>`<button class="slot ${sell.slot===x?'on':''}" data-sellslot="${x}">${x}</button>`).join('')}</div>
        <p class="obnote">${meet?`We contact you to agree on a public place near you.`:`We let you know 30 minutes before arriving.`} The device is tested in front of you and paid on the spot, ${sell.pay==='cash'?'in cash':'by Interac e-Transfer'}.</p>
      </div>
      <button class="btn wide" style="margin-top:14px" data-sellaccept ${sell.slot?'':'disabled'}>${meet?'Confirm meetup':'Confirm pickup'}${sell.slot?' · '+sell.slot:''}</button>`
      :`
      <div class="nextsteps">
        <div><i>1</i><b>Check your inbox</b><p>A prepaid label and a QR code reach you within the hour, by email or text. No printer? Show the QR code at the counter.</p></div>
        <div><i>2</i><b>Drop it off</b><p>Any Canada Post, Purolator or UPS location. Keep the receipt for tracking.</p></div>
        <div><i>3</i><b>Get paid</b><p>Tested within two business days of arrival. If it matches, the e-Transfer goes out the same day. If not, we offer a new price first, and send it back free if you say no.</p></div>
      </div>
      <button class="btn wide line" style="margin-top:14px" data-sellaccept>Resend my label</button>`}

      <div class="card2" style="margin-top:18px">
        <h3>Before you hand it over</h3>
        <ul class="qlines" style="margin:0">
          <li><span>Sign out of iCloud or Google</span><b><a class="seclink" href="#/care/icloud">How</a></b></li>
          <li><span>Erase it and remove the SIM</span><b><a class="seclink" href="#/care/wipe">How</a></b></li>
          <li><span>Photo ID ready${pick?' for the pickup':' (a copy goes in the box)'}</span><b></b></li>
        </ul>
      </div>
      <button class="backlink" style="margin-top:16px" data-sellreset>Start over</button>`;
  }

  if(sell.step===6){
    const r=store.get('records',[]).find(x=>x.ref===sell.ref);
    inner = r ? `<div class="donebox big" style="margin-top:14px"><b>Request received</b>
        <p>${r.handoff==='ship' ? 'Your prepaid label and QR code are on their way.' : (r.handoff==='meet' ? `We will confirm a public meeting place for ${r.slot?r.slot.replace(/^(Today|Tomorrow|Saturday)/,m=>m.toLowerCase()==='saturday'?'Saturday':m.toLowerCase()):'the time we agree'}.` : `We will be there ${r.slot?r.slot.replace(/^(Today|Tomorrow)/,m=>m.toLowerCase()).replace(/^Saturday/,'on Saturday'):'at the time we agree'}.`)} ${/@/.test(r.contact)?'Confirmation sent to':'We will text you at'} ${r.contact}.</p>
        <p class="ref">Reference <strong>${r.ref}</strong></p></div>
      <div class="card2" style="margin-top:16px">${r.devices.map(d=>`<div class="qrow"><span>${d.model}<small>${d.spec}</small></span><b>${money(d.value)}</b></div>`).join('')}
        <div class="qrow tot"><span>Total offer</span><b>${money(r.total)}</b></div></div>
      <a class="btn wide line" style="margin-top:14px" href="#/care/track">Track this request</a>
      <button class="backlink" style="margin-top:16px" data-sellreset>Sell another device</button>` : '';
  }
  const banner = sell.step===0 ? `
    <div class="sellban">
      <div class="shell">
        <h1>Sell your phone for cash<br>in Ottawa–Gatineau</h1>
        <p>A firm offer in about a minute, held for 14 days.<br>Free pickup, or a prepaid label anywhere in Canada.</p>
      </div>
    </div>` : `
    <div class="sellslim"><div class="shell">Sell your device</div></div>`;
  return `${banner}
    <div class="shell" style="max-width:620px;padding-top:${sell.step===0?18:10}px;padding-bottom:30px">${inner}${sell.step===0?`
      <section class="sellarea">
        <h2>Where we pick up</h2>
        <p>Free pickup at your home or office across Ottawa and Gatineau, including Kanata, Orléans, Barrhaven, Nepean, Stittsville, Gloucester, Hull and Aylmer, or we meet in a public place. Anywhere else in Canada, we send you a free prepaid, tracked label. You’re paid by Interac e-Transfer or cash.</p>
      </section>
      <div class="sellguides"><p>Before you sell</p>
        <a href="/blogs/guides/how-much-is-my-used-iphone-worth-in-canada"><span>How much is my used iPhone worth in Canada?</span><i aria-hidden="true">›</i></a>
        <a href="/blogs/guides/where-to-sell-your-iphone-in-ottawa"><span>Where to sell your iPhone in Ottawa: every option, compared</span><i aria-hidden="true">›</i></a>
      </div>`:''}</div>`;
}

function pageCheckout(){
  if(!state.cart.length) return `<div class="shell"><div class="empty"><p style="color:var(--ink);font-size:16.5px;font-weight:700">Nothing to check out yet</p><a class="btn" href="#/shop" style="margin-top:14px">Shop devices</a></div></div>`;
  const sub=cartTotal(), ship=sub>=FREE_SHIP?0:14, tax=Math.round((sub+ship)*0.13), tot=sub+ship+tax;
  const count=state.cart.reduce((a,i)=>a+i.qty,0);
  return `<div class="shell co">
    <div class="crumbs pxcrumbs"><a href="#/">Home</a> / Checkout</div>
    <h1 class="coh1">Checkout</h1>
    <div class="cogrid">
      <aside class="cosum">
        <div class="cobox">
          <p class="colabel">Order summary · ${count} item${count>1?'s':''}</p>
          ${state.cart.map(i=>`<div class="coitem"><div class="coimg">${art(i.art,i.name,40)}${i.qty>1?`<i>${i.qty}</i>`:''}</div>
            <div><b>${i.name}</b><span>${optLine(i,GRADES[i.grade].label)}</span></div>
            <strong>${money(i.price*i.qty)}</strong></div>`).join('')}
          <dl class="cotot">
            <div><dt>Subtotal</dt><dd>${money(sub)}</dd></div>
            <div><dt>Shipping</dt><dd>${ship?money(ship):'Free'}</dd></div>
            <div><dt>HST (13%)</dt><dd>${money(tax)}</dd></div>
            <div class="big"><dt>Total</dt><dd><small>CAD</small> ${money(tot)}</dd></div>
          </dl>
          <ul class="coperks"><li>${ico('shield',16)}12-month warranty</li><li>${ico('rotate',16)}30-day returns</li></ul>
        </div>
      </aside>
      <div class="coform">
        <p class="colabel">Express checkout</p>
        <div class="coexpress"><button class="xpay apple" onclick="toast('Apple Pay opens here on a live site')"> Pay</button><button class="xpay gpay" onclick="toast('Google Pay opens here on a live site')">G Pay</button></div>
        <div class="coor"><span>or</span></div>

        <h2 class="coh2">Contact</h2>
        <input class="field" id="coContact" autocomplete="email" placeholder="Email or phone number">
        <h2 class="coh2">Delivery</h2>
        <input class="field" id="coName" autocomplete="name" placeholder="Full name">
        <input class="field" id="coAddr" autocomplete="street-address" placeholder="Address">
        <input class="field" id="coCity" autocomplete="address-level2" placeholder="City, province, postal code">
        <div class="coship">${ico('truck',18)}<div><b>${ship?'Tracked delivery · '+money(ship):'Free tracked delivery'}</b><span>Arrives ${delivery().range}</span></div></div>
        <p class="err" id="coErr"></p>
        <button class="btn wide cobtn" id="payBtn">${ico('lock',16)} Pay ${money(tot)}</button>
        <div class="paytrust"><span>Visa</span><span>Mastercard</span><span>Amex</span><span>Interac</span><span>Apple Pay</span><span>Google Pay</span></div>
        <p class="cofine">Demo checkout. No payment is taken.</p>
      </div>
    </div>
  </div>`;
}

const CARE = {
  stolen:{s:'Photo ID and a lost-and-stolen check on every device we buy.', t:'Stolen devices and ID checks', b:`
    <p>A buyback business only works if people can trust that what it sells was not taken from someone. So we check before we pay, every time.</p>
    <ol class="steps-list">
      <li>Every seller shows government photo ID, at pickup or with the shipped device, and we keep a record against the serial number.</li>
      <li>We check the IMEI or serial against the carriers' lost and stolen database before any payment goes out.</li>
      <li>Devices must be signed out of iCloud, Google or Samsung accounts. A locked device is not bought until the owner removes the lock.</li>
      <li>A device that comes back flagged is held, not paid for, and the matter is referred to police.</li>
    </ol>
    <p>If your phone was stolen and you think it reached us, contact us with the serial number or IMEI and a police report number. We check our records the same day.</p>
    <a class="btn wide" href="#/care/contact">Report a stolen device</a>`},
  battery:{s:'Where to find battery health on iPhone, Galaxy and MacBook.', t:'How to check battery health', b:`
    <p>Battery health is the first thing that decides a device's value, ours and yours. Here is where to find it.</p>
    <h3>iPhone</h3>
    <p>Settings › Battery › Battery Health &amp; Charging. The number next to Maximum Capacity is what we mean by battery health. On iPhone 15 and newer, the same screen shows the cycle count.</p>
    <h3>Samsung Galaxy</h3>
    <p>Open the Samsung Members app › Support › Phone diagnostics › Battery status. It shows the battery life as Good, Normal or Weak.</p>
    <h3>MacBook</h3>
    <p>System Settings › Battery › the info button next to Battery Health. For the cycle count, hold Option, click the Apple menu › System Information › Power.</p>
    <p>Every device we sell has a battery at 80% health or better. Below that, we replace the battery before it goes on sale.</p>`},
  icloud:{s:'Sign out of iCloud or Google so the device can be sold.', t:'How to remove iCloud or Google lock', b:`
    <p>A phone still signed in to its owner's account is locked to them, even after a reset. Nobody can use it, including us. Remove the lock before you sell.</p>
    <h3>iPhone or iPad</h3>
    <ol class="steps-list">
      <li>Settings › your name at the top › Sign Out.</li>
      <li>Enter your Apple Account password to turn off Find My.</li>
      <li>If the device is already gone, sign in at iCloud.com › Find Devices, select it, and choose Remove This Device.</li>
    </ol>
    <h3>Samsung or other Android</h3>
    <ol class="steps-list">
      <li>Settings › Accounts and backup › Manage accounts.</li>
      <li>Remove your Google account and your Samsung account.</li>
      <li>Then reset the phone. Removing the accounts first is what lifts the lock.</li>
    </ol>`},
  wipe:{s:'Back up, sign out and erase in five steps.', t:'How to wipe your phone before selling', b:`
    <p>We erase every device we buy and log the erasure. Doing it yourself first means your data never leaves your hands.</p>
    <ol class="steps-list">
      <li><b>Back up.</b> iCloud or your computer for iPhone, Google or Samsung Cloud for Android.</li>
      <li><b>Unpair your watch</b> if you have an Apple Watch, so it keeps its own backup.</li>
      <li><b>Sign out</b> of iCloud or Google, as in our lock guide.</li>
      <li><b>Erase.</b> iPhone: Settings › General › Transfer or Reset iPhone › Erase All Content and Settings. Samsung: Settings › General management › Reset › Factory data reset.</li>
      <li><b>Take out the SIM card</b>, or delete the eSIM when the phone asks during the erase.</li>
    </ol>
    <p>Not sure you did it right? Send it anyway. We check, and we wipe again regardless.</p>`},
  grading:{s:'Excellent, Good and Fair describe looks only. Every grade is 100% functional.', t:'How grading works', b:`
    <p>Every device we sell is Deviceli Certified: a 30-point inspection, 100% functional, battery at 80% health or better, wiped and logged, 12 months of warranty. The grade only describes how it looks.</p>
    <ul class="hilites">
      <li><b>Excellent</b><span>Almost no signs of use. Flawless screen, micro-scratches on the body invisible from 20 cm.</span></li>
      <li><b>Good, about 9% less</b><span>Light signs of use. Flawless screen, light micro-scratches on the body invisible from 50 cm.</span></li>
      <li><b>Fair, about 18% less</b><span>Visible signs of use. Scratches or small dents on the body, light screen scratches visible only when it is on.</span></li>
    </ul>
    <p>If the device you receive looks worse than its grade, send it back. We pay the shipping.</p>`},
  warranty:{s:'12 months, parts and labour. We pay shipping both ways.', t:'Warranty claim', b:`
    <p>Every device is covered 12 months from delivery, parts and labour, against any hardware fault that is not accidental damage. We repair, replace or refund, and we pay shipping both ways.</p>
    <h3>Start a claim</h3>
    <p class="hint">Order number, device and a short description of the fault. We answer within one business day.</p>
    <div data-form="warranty">
      <input class="field" name="order" placeholder="Order number" data-req>
      <input class="field" name="email" placeholder="Email" data-req data-type="email">
      <textarea class="field" name="message" rows="3" placeholder="What is happening with the device?" data-req></textarea>
      <button class="btn wide" data-submit>Send the claim</button>
    </div>`},
  returns:{s:'30 days, no restocking fee. Free if it arrives defective.', t:'Start a return', b:`
    <p>30 days from delivery, in the condition you received it, with no restocking fee. If it arrives defective or not as described, we pay the return shipping. If you changed your mind, return shipping is at your cost. Refunds go to your original payment method, usually within 5 business days of the device arriving.</p>
    <h3>Request a label</h3>
    <div data-form="returns">
      <input class="field" name="order" placeholder="Order number" data-req>
      <input class="field" name="email" placeholder="Email" data-req data-type="email">
      <button class="btn wide" data-submit>Email me a return label</button>
    </div>`},
  track:{s:'Find your order with its reference, email or phone number.', t:'Track an order', b:`
    <p>Orders placed before 2pm on a business day ship the same day, tracked. You also get the tracking number by email as soon as the label is printed.</p>
    <div data-form="track">
      <input class="field" name="q" placeholder="Reference number, email or phone" data-req>
      <button class="btn wide" data-submit>Find it</button>
      <div class="trackout"></div>
    </div>`},
  data:{s:'Every device we buy is erased and the wipe is logged.', t:'Data wiping', b:`
    <p>Every device we buy is wiped to factory state and the wipe is logged against the serial number. Nothing is resold before that log exists.</p>
    <h3>Before you send us a device</h3>
    <ol class="steps-list">
      <li>Back up what you want to keep.</li>
      <li>Sign out of iCloud, or remove your Google account. We cannot process a device that is still account-locked.</li>
      <li>Erase all content and settings if you can. If you cannot, we do it on arrival.</li>
    </ol>`},
  pickup:{s:'Free pickup in Ottawa–Gatineau for devices you sell us.', t:'Local pickup for sellers', b:`
    <p>For devices we buy, we come to you. Free pickup across Ottawa, Gatineau and the surrounding area, often the same day you accept the offer.</p>
    <p>There is no storefront to visit. Everything we sell ships to you, tracked.</p>
    <ul class="hilites">
      <li><b>How pickup works</b><span>Accept the offer and choose a window. We test the device in front of you and pay on the spot, in cash or by Interac e-Transfer.</span></li>
      <li><b>Have photo ID ready</b><span>We log every device we buy against the seller's photo ID, and share those records with police on request.</span></li>
      <li><b>Outside the region</b><span>A prepaid label reaches you by email. We cover the postage, both directions if you decline a revised offer.</span></li>
    </ul>`},
  contact:{s:'A real person answers, usually within one business day.', t:'Contact us', b:`
    <p>A real person answers, usually within one business day. We speak English and French.</p>
    <div data-form="contact">
      <input class="field" name="name" placeholder="Your name" data-req>
      <input class="field" name="email" placeholder="Email or phone number" data-req data-type="contact">
      <textarea class="field" name="message" rows="3" placeholder="How can we help?" data-req></textarea>
      <button class="btn wide" data-submit>Send</button>
    </div>`},
  privacy:{s:'What we collect, why, and how to have it deleted.', t:'Privacy', b:`
    <p>We collect only what an order or a buyback needs: your name, email or phone, and a delivery address. For devices we buy, we also record the serial number or IMEI and the seller's photo ID.</p>
    <ul class="steps-list">
      <li>We use it to deliver, support and warranty your order, and to pay you for a device you sell.</li>
      <li>We never sell your information. Payment details are handled by the payment provider, not stored by us.</li>
      <li>Buyback ID records are kept to prevent the resale of stolen devices and shared with police on request.</li>
      <li>To see or delete what we hold about you, <a class="seclink" href="#/care/contact">contact us</a>.</li>
    </ul>`},
  terms:{s:'Prices, warranty, returns and buyback offers in plain terms.', t:'Terms', b:`
    <ul class="steps-list">
      <li>Prices are in Canadian dollars. HST is added at checkout.</li>
      <li>Every device is covered 12 months from delivery against hardware faults that are not accidental damage.</li>
      <li>You can return a device within 30 days of delivery, in the condition you received it. Return shipping is free if it arrives defective or not as described; otherwise it is at your cost.</li>
      <li>A buyback offer is held 14 days and paid in full if the device matches your description. If it does not, we offer a revised price, and return the device free if you decline.</li>
      <li>By selling a device, you confirm that you own it and that it is not lost, stolen or financed with a carrier we do not accept.</li>
    </ul>`},
  business:{s:'Volume orders and fleet buyback for businesses.', t:'Business and bulk', b:`
    <p>Ten devices or a hundred. Volume pricing, net terms for repeat accounts, and one contact who answers. We also buy back fleets when you refresh.</p>
    <div data-form="business">
      <input class="field" name="company" placeholder="Company" data-req>
      <input class="field" name="email" placeholder="Work email or phone" data-req data-type="contact">
      <textarea class="field" name="message" rows="3" placeholder="What do you need, and how many?" data-req></textarea>
      <button class="btn wide" data-submit>Talk to us</button>
    </div>`}
};

function pageCare(topic){
  CARE.track = {s:'Your order status link is in your confirmation email.', t:'Track an order', b:`<p>Every order confirmation email has a link to its live status and tracking number. You can also sign in to your account to see all your orders.</p><a class="btn wide" href="/account">Go to my account</a>`};
  CARE.returns = {s:'30 days, no restocking fee. Free if it arrives defective.', t:'Start a return', b:`<p>30 days from delivery, in the condition you received it, with no restocking fee. If it arrives defective or not as described, we pay the return shipping. If you changed your mind, return shipping is at your cost. Refunds go to your original payment method, usually within 5 business days of the device arriving.</p><a class="btn wide" href="/account">Request a return from my account</a>`};

  const keys=['warranty','returns','track','grading','pickup','battery','icloud','wipe','data','stolen','contact','business','privacy','terms'].filter(x=>CARE[x]);
  const k = CARE[topic] ? topic : null;
  const body = k ? `
    <a class="backlink" href="#/care">‹ All help topics</a>
    <h1 class="carehead">${CARE[k].t}</h1>
    <div class="carebody">${CARE[k].b}</div>` : `
    <h1 class="carehead">How can we help?</h1>
    ${[['Your order',['track','returns','warranty','grading']],['Selling to us',['pickup','battery','icloud','wipe','data','stolen']],['Get in touch',['contact','business']],['Policies',['privacy','terms']]].map(([g,ks])=>`
    <p class="cglabel">${g}</p>
    <div class="cglist">${ks.filter(x=>CARE[x]).map(x=>`<a href="#/care/${x}"><span><b>${CARE[x].t}</b><small>${CARE[x].s}</small></span><i aria-hidden="true">›</i></a>`).join('')}</div>`).join('')}`;
  return `<div class="sell-hero"><div class="shell"><h1>Deviceli Care</h1><p>Help with your order, your warranty and selling your device.</p></div></div>
    <div class="shell" style="max-width:680px;padding-top:22px;padding-bottom:36px">${body}
    <div style="height:22px"></div>
    ${tradeBanner(false)}
    </div>`;
}

